import api from './api';

function extractAuthPayload(response) {
  return response?.data?.dataset?.data || {};
}

export async function loginUser(payload) {
  const response = await api.post('/login', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function loginWithWebLink(token) {
  const response = await api.post('/device-login', { token, login_channel: 'web' });
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function fetchCurrentUser() {
  const response = await api.post('/me');
  return response?.data || null;
}

export async function logoutUser() {
  const response = await api.post('/logout');
  return response?.data || null;
}

export async function signUpUser(payload) {
  const response = await api.post('/signup', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function verifySignUpOtp(payload) {
  const response = await api.post('/signup-verification', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function resendSignUpOtp(payload) {
  const response = await api.get('/signup-verification-recode', {
    params: payload,
  });

  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function requestForgotPasswordOtp(payload) {
  const response = await api.post('/forgot-password', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function resendForgotPasswordOtp(payload) {
  const response = await api.get('/forgot-password-recode', {
    params: payload,
  });
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function verifyForgotPasswordOtp(payload) {
  const response = await api.post('/forgot-password-verification', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function resetForgottenPassword(payload) {
  const response = await api.post('/create-new-password', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function changePassword(payload) {
  const response = await api.post('/change-password', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function storeUserLanguage(payload) {
  const response = await api.post('/user-management/store-language', payload);
  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}

export async function fetchTutorials(selectedLang = 'EN') {
  const response = await api.get('/tutorial', {
    params: { selected_lang: selectedLang },
  });

  return {
    payload: extractAuthPayload(response),
    meta: response?.data || {},
  };
}
